import { render, staticRenderFns } from "./detalhes-materiais.vue?vue&type=template&id=6d2ef958&scoped=true&"
import script from "./detalhes-materiais.vue?vue&type=script&lang=js&"
export * from "./detalhes-materiais.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=6d2ef958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ef958",
  null
  
)

export default component.exports